import {
  SipSettingState,
  SipSettingActionTypes,
  GET_SIP_SETTING_PENDING,
  GET_SIP_SETTING_FULFILLED,
  SELECT_SIP_SETTING,
  DELETE_SIP_SETTING,
  DELETE_SIP_SETTING_FULFILLED,
  SET_SIP_SETTING_LOADING,
  UPDATE_SIP_ERRORS,
  CREATE_SIP_SETTING,
  UPDATE_SIP_SETTING
} from './sipSetting.types';

export const initialState: SipSettingState = {
  entities: [],
  selected: [],
  single: null,
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isLoading: false,
  },
  sipSettingErrors: {
    sipInfo: [],
    sipTimer: [],
    prefixes: [],
    networkElements: [],
    hasError: false,
  }
};

export default function dialedDigitExtractionServerReducer(
  state = initialState,
  action: SipSettingActionTypes,
): SipSettingState {
  switch (action.type) {

    case GET_SIP_SETTING_PENDING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: true,
        }
      };

    case GET_SIP_SETTING_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
        ui: {
          ...state.ui,
          isLoading: false,
        }
      };

    case SELECT_SIP_SETTING:
      return {
        ...state,
        selected: action.payload || [],
      };

    case DELETE_SIP_SETTING:
      return {
        ...state,
        selected: [],
        sipSettingErrors: initialState.sipSettingErrors
      };

    case DELETE_SIP_SETTING_FULFILLED:
      return {
        ...state,
        selected: [],
      };

    case SET_SIP_SETTING_LOADING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

    case UPDATE_SIP_ERRORS:
      return {
        ...state,
        sipSettingErrors: action.payload
      };

    case CREATE_SIP_SETTING:
      return {
        ...state,
        sipSettingErrors: initialState.sipSettingErrors
      };

    case UPDATE_SIP_SETTING:
      return {
        ...state,
        sipSettingErrors: initialState.sipSettingErrors
      };
    default:
      return state;
  }
}
